<template lang="pug">
  v-slide-y-transition(mode="out-in")
    v-container(fluid)
      confirm(ref="confirm")

      v-toolbar.mb-3(dark, color="primary")
        v-text-field(append-icon="search", :elevation="1", label="Filtrar", @keyup="handleSearchKeyUp", single-line, hide-details, v-model="search.text")
        v-btn(text, class="right", to="/invoices/create") Añadir nueva factura

      v-btn-toggle.mb-3(v-model="search.serie")
        v-btn(text, color="green", value="invoices") Facturas
        v-btn(text, color="red", value="credits") Abonos

      v-data-table.elevation-1(:loading="isLoading()", :headers="tableHeaders", disable-pagination, :items="filteredInvoices", hide-default-footer)
        template(v-slot:item.reference="{ item }")
          span(:class="{credit: item.credit}", style="white-space: nowrap") {{item.serie}}-{{item.reference}}
          span(v-if="item.credit", style="white-space: nowrap").ml-2 {{item.credit.serie}}-{{item.credit.reference}}
        template(v-slot:item.date="{ item }") {{item.createdAt | formatDate}}
        template(v-slot:item.customer="{ item }")
          span(v-html="getInvoiceCustomerName(item)")
        template(v-slot:item.details="{ item }")
          span(v-html="getDetailsList(item)")
        template(v-slot:item.total="{ item }")
          span(:title="item.subtotal") {{item.total | currency}}
        template(v-slot:item.options="{ item }")
          v-btn(:href="getInvoiceUrl(item)", target="_blank", text, icon, color="success")
            v-icon file_download
          v-btn(v-if="!item.credit && item.serie !== 'FA'", text, icon, color="primary", :to="`/invoices/${item.id}/edit`")
            v-icon edit
          v-btn(v-if="item.serie === 'FP'", @click="handleDelete(item)", text, icon, color="red")
            v-icon delete
          v-btn(v-if="item.serie !== 'FA' && item.serie !== 'FP' && !item.credit", @click="handleDelete(item)", text, icon, color="red")
            v-icon money_off

      v-layout(flex align-center justify-center)
        v-btn(text, color="blue", style="margin: 20px 0 0", @click="loadNextPage") Cargar más
</template>

<style scoped>
.loader {
  text-align: center;
  padding: 20px 0;
}
.credit {
  color: red;
  text-decoration: line-through;
}
</style>

<script>
import { formatDate } from "@/utils/filters";

export default {
  data() {
    return {
      currentPage: null,
      currentSearchText: "",
      search: {
        text: "",
        serie: "invoices",
      },
      loading: false,
      invoices: [],
      tableHeaders: [
        {
          text: "Factura",
          align: "center",
          value: "reference",
          sortable: false,
          width: "100px",
        },
        {
          text: "Fecha",
          align: "left",
          value: "date",
          sortable: false,
          width: "100px",
        },
        {
          text: "Cliente",
          align: "left",
          value: "customer",
          sortable: false,
        },
        {
          text: "Estancias",
          align: "left",
          sortable: false,
          value: "details",
        },
        {
          text: "Total",
          align: "right",
          value: "total",
          sortable: false,
        },
        {
          text: "Opciones",
          align: "right",
          sortable: false,
          value: "options",
        },
      ],
    };
  },
  created() {
    this.fetchPage(0);
  },
  computed: {
    filteredInvoices() {
      if (this.search.serie === "credits") {
        return this.invoices.filter((i) => i.serie === "FA");
      }
      return this.invoices.filter((i) => i.serie !== "FA");
    },
  },
  methods: {
    formatDate,
    isLoading() {
      return this.loading;
    },
    fetchPage(page, searchText) {
      if (typeof searchText !== "undefined") {
        this.currentSearchText = searchText;
      }
      this.currentPage = page;
      this.loading = true;
      if (page === 0) {
        this.invoices = [];
      }
      api
        .get(`/invoices?page=${page}&search=${this.currentSearchText}`)
        .then((res) => {
          this.invoices = [...this.invoices, ...res.data.data];
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadNextPage() {
      this.fetchPage(this.currentPage + 1);
    },
    getInvoiceCustomerName(item) {
      let showName = item.company.name;
      if (item.finalCustomer) {
        showName += `<br><small>${item.finalCustomer}</small>`;
      }
      return showName;
    },
    getCustomerName(item) {
      let showName = "";
      if (item.user && item.user.info) {
        if (item.user.info.fiscalName) {
          showName = item.user.info.fiscalName;
        }
        if (item.user.info.commercialName) {
          showName = item.user.info.commercialName;
        }
      } else {
        showName = item.user.email;
      }
      if (item.finalCustomer) {
        showName += ` (${item.finalCustomer})`;
      }
      return showName;
    },
    handleConfirm(item) {
      this.$refs.confirm.open("Confirmar", "¿Estás seguro?").then((confirm) => {
        if (confirm) {
          api
            .put(`/invoices/${item.id}/confirm`)
            .then(() => {
              this.invoices[this.invoices.indexOf(item)].status = "CONFIRMED";
            })
            .catch(this.handleError);
        }
      });
    },
    getDetailsList(item) {
      const list = [];
      item.details.forEach((i) => {
        const reference = i.reference ? `${i.reference} - ` : "";
        list.push(reference + i.description);
      });
      return list.join("<br>");
    },
    getInvoiceUrl(item) {
      return `//${process.env.API_HOST}/invoices/${item.id}/pdf?token=${store.state.user.token}`;
    },
    handleSearchKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.fetchPage(0, this.search.text);
      }
    },
    handleDelete(item) {
      this.$refs.confirm
        .open("Crear abono", "¿Estás seguro?")
        .then((confirm) => {
          if (confirm) {
            api
              .delete(`/invoices/${item.id}`)
              .then(() => {
                this.fetchPage();
              })
              .catch(this.handleError);
          }
        });
    },
    handleError(err) {
      // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Invoices/Invoices.vue